import React from 'react';
import InfoToggle from '../../../../ComponentsV1/InfoToggle';

const ORDER_ID_COLOR = '#0366D6';

const OrderItems = ({ orderItems }) => {
  const items = (orderItems || []).filter((item) => item?.name);

  if (!items.length) {
    return (
      <div className='tw-mt-4 tw-text-[1.3rem] tw-font-regular tw-text-zinc-400'>
        No item details available
      </div>
    );
  }

  return (
    <div className='tw-flex tw-flex-col tw-gap-3 tw-mt-4'>
      {items.map((item, index) => (
        <div
          className='tw-w-full tw-flex tw-justify-between tw-items-center tw-gap-4'
          key={`${item.name}-${index}`}
        >
          <span className='tw-text-[1.3rem] tw-font-regular tw-text-grey-700'>
            {item.name}
          </span>
          <span className='tw-text-[1.3rem] tw-font-regular tw-text-grey-600 tw-whitespace-nowrap'>
            {item.quantity ? `x ${item.quantity}` : '-'}
          </span>
        </div>
      ))}
    </div>
  );
};

export const CancellationWarning = ({ warning = null }) => {
  if (!warning?.title) return null;

  const affectedOrders = (warning.affected_orders || []).filter(
    (order) => order?.external_order_id || order?.order_id,
  );

  return (
    <div className='tw-flex tw-flex-col tw-gap-6 tw-mt-8'>
      <div className='tw-text-[1.4rem] tw-font-medium tw-leading-snug tw-text-red-600'>
        {warning.title}
      </div>

      {affectedOrders.map((order) => (
        <InfoToggle
          key={order.order_id ?? order.external_order_id}
          title={
            <div className='tw-text-[1.5rem]' style={{ color: ORDER_ID_COLOR }}>
              {order.external_order_id || order.order_id}
            </div>
          }
          showBorder={true}
          borderStyles='tw-border tw-border-solid tw-border-grey-200'
          styles='tw-p-4 tw-h-full tw-bg-grey-100/50'
        >
          <OrderItems orderItems={order.order_items} />
        </InfoToggle>
      ))}
    </div>
  );
};
